// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"415":"component---src-pages-404-jsx","838":"component---src-templates-shop-jsx"}[chunkId] || chunkId) + "-" + {"415":"dbc52de86e80c93e4044","454":"3e65623039a84aae75c7","838":"c58ad7aaebae829f7b30"}[chunkId] + ".js";
};